import { useAnalysis } from "@/contexts/AnalysisContext";
import { DiffAnalysisSheet } from "./DiffAnalysisSheet";

export function GlobalAnalysisSheet() {
  const { isOpen, filters, closeAnalysis } = useAnalysis();

  if (!filters) return null;

  return (
    <DiffAnalysisSheet
      open={isOpen}
      onOpenChange={closeAnalysis}
      filters={filters}
    />
  );
}
